// @flow
import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { createSession } from '../redux/actions';
import '../assets/pricing.css';

type PlansItems = {
    id: number,
    name: string,
    icon: string,
    price: string,
    duration: string,
    features: Array<string>,
    isRecommended: boolean,
};

type PricingCardProps = {
    plans: Array<PlansItems>,
    containerClass?: string,
};

const PricingCard = ({ plans, containerClass }: PricingCardProps): React$Element<any> => {
  const dispatch = useDispatch();

  const subscribe = (planId, isYearly) => {
    debugger
    //dispatch the stripe action
    dispatch(createSession({
      data: {
        planId: planId,
        isYearly: isYearly
      }
    }))
  }

    return (
        <>
            <Row className={containerClass}>
                {plans.map((plan, idx) => {
                    return (
                        <Col md={4} key={idx}>
                            <Card
                                className={classNames('card-pricing', {
                                    'card-pricing-recommended': plan.isRecommended,
                                })} style={{backgroundColor: '#242424'}}>
                                <Card.Body className="text-center" style={{fontFamily: 'Comfortaa', color: 'white'}}>
                                    {plan.isRecommended && <div className="card-pricing-plan-tag">Recommended</div>}
                                    <h3 className="card-pricing-plan-name fw-bold text-uppercase" style={{color: '#cf7711'}}>{plan.name}</h3>
                                    <i className={classNames('card-pricing-icon', plan.icon, 'text-primary')}></i>
                                    <h2 className="card-pricing-price">
                                        {plan.monthlyPrice} <span style={{color: 'white'}}>/ Month</span>
                                    </h2>
                                    Or
                                    <h2 className="card-pricing-price" style={{paddingTop:'5px'}}>
                                        {plan.yearlyPrice} <span style={{color: 'white'}}>/ Year</span>
                                    </h2>
                                    <ul className="card-pricing-features" style={{color: 'white', fontSize: '1.2rem'}}>
                                        {plan.features.map((feature, idx1) => {
                                            return <li key={idx1}>{feature}</li>;
                                        })}
                                    </ul>
                                    <button onClick={() => {subscribe(plan.planId, false)}} className="btn btn-primary mt-4 mb-2 btn-rounded" style={{backgroundColor: "#cf7711", borderColor: "#cf7711", fontSize: '1.5rem'}}>Choose Monthly Plan</button>
                                    <button onClick={() => {subscribe(plan.planId, true)}} className="btn btn-primary mt-4 mb-2 btn-rounded" style={{backgroundColor: "#cf7711", borderColor: "#cf7711", fontSize: '1.5rem'}}>Choose Yearly Plan</button>
                                </Card.Body>
                            </Card>
                        </Col>
                    );
                })}
            </Row>
        </>
    );
};

export default PricingCard;
